import { Pipe, PipeTransform } from '@angular/core';
import { Observable, isObservable, of } from 'rxjs';

@Pipe({
	name: 'boolLikeToObservableBool',
	standalone: true,
})
export class BooLikeToObservableOfBoolPipe implements PipeTransform {
	transform(value: (() => boolean) | boolean | undefined | Observable<boolean>): Observable<boolean> {
		if (value === undefined) {
			return of(true);
		}

		if (isObservable(value)) {
			return value;
		}

		return of(typeof value === 'function' ? value() : value);
	}
}
